import './App.css';
import { Routes, Route } from 'react-router-dom';
import { DataProvider } from './contexts/DataContext.jsx';
import DynamicContent from './components/DynamicContent.js';
import HomePage from './components/HomePage.js'
import NotFoundPage from './pages/NotFoundPage.js'
import Header from './components/Header.js';
import Footer from './components/Footer.js'
import Contact from './pages/Contact.js'
import Search from './pages/Search.jsx'; // Search 컴포넌트 임포트


function App() {
  return (
    <DataProvider>
      <div className="toolkit">
        <Header />
        <main>
        <Routes>
            <Route path="/search" element={<Search />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/:category" element={<DynamicContent />} />
            <Route path="/:category/:subcategory" element={<DynamicContent />} />
            <Route path='/contact' element={<Contact />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
        </main>
        <Footer />
      </div>
      </DataProvider>
  );
}

export default App;
